 export default {
  props: ['loftieClockProductTitle', 'clockPrice', 'loftiePlusAnnualPrice', 'typeOfLoftiePlus', 'currency'],
   methods: {
    closeUpsell() {
      window.store.commit('toggleLoftieClockUpsell', false);
    }
  },
  computed: {
    priceDifference() {
      return ((this.clockPrice - this.loftiePlusAnnualPrice) / 100).toFixed(2);
    },
    formattedClockPrice() {
      return (this.clockPrice / 100).toFixed(2);
    }
  },
  template: `
    <div class="lpt_upsell--wrapper">
      <h4 class="lpt_upsell--header">Upgrade to the full sleep experience:</h4>
      <div class="lpt_upsell--border_wrapper">
        <div class="lpt_upsell--slide">
          <svg id="loftieClockCloseIcon" width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" @click="closeUpsell">
            <g clip-path="url(#clip0_1634_16194)">
              <path d="M0.416992 0.416016L19.5837 19.5827" stroke="#909090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.5837 0.416016L0.416992 19.5827" stroke="#909090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_1634_16194">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <img class="lpt_upsell--img"  src="https://cdn.shopify.com/s/files/1/0268/3823/7231/files/LoftieSystem.jpg?v=1750102329&width=200" :alt="loftieClockProductTitle" >
          <div class="lpt_upsell--right_column">
          <div class="lct_upsell-row">
            <h5 class="lpt_upsell--title">Loftie System</h5>
            <div class="lct_upsell--price_wrapper">
              <span v-if="typeOfLoftiePlus === 'annual'">{{currency}}{{ priceDifference }}</span>
              <span :style="{ textDecoration: typeOfLoftiePlus === 'annual' ? 'line-through' : 'none' }">
                {{currency}}{{ formattedClockPrice }}
              </span>
            </div>
          </div>
            <a href="/products/loftie?upgrade=clock-only">
              <button class="lpt_upsell--btn">
                <span>Upgrade</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  `
}